import { countTypeEnum, DeheadingReportingTypeEnum, ProductionProcessTypeEnum } from "@gtpl/shared-models/common-models";
import { QualityTypeEnum } from "libs/shared-models/common-models/src/lib/enum/supplier-type.enum";

export class prodOpCreateReq{
    operation?:string;
    prevOperation?:string;
    lotNumber?:string;
    prevOpOutProduct?:number;
    countType?:string;
    count?:number
}

export class prodOpReq{
    operation?:any;
    prevOperation?:any;
    lotNumber?:string;
    plantId?:number;
    date?:Date;
    count?:string;
    variantName?:string;
    inputQuantity?:number;
    createdUser?:string;
    variantId?:number;
    quality?:QualityTypeEnum;
    prodInvId?:number;
    remarks?:string
    countType?:countTypeEnum
    processType?:ProductionProcessTypeEnum
}

export class prodOpOutputReq{
    operation?:any;
    prevOperation?:any;
    lotNumber?:string;
    plantId?:number;
    date?:Date;
    count?:string;
    variantName?:string;
    inputQuantity?:number;
    createdUser?:string;
    variantId?:number;
    quality?:QualityTypeEnum;
    prodInvId?:number;
    outPutQuantity?:number
    productionLogId?:number
    reportingType?:DeheadingReportingTypeEnum
    remarks?:string
     countType?:countTypeEnum
     inputCount?:string
     inputCountType?:countTypeEnum
}

export class prodOpViewReq{
    tabName?:string[];
    operation?:string[];
    prevOperation?:string;
    lotNumber?:string;
    inVariantId?:number;
    outVariantId?:number;
    workOrderNo?:string;
    product?:string
}
